export default __webpack_public_path__ + "static/media/Staking dark mode.38068cc7.png";